// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2jQ_Z","balanceDisclaimer":"posDashboard_balanceDisclaimer__2bXEh"};